'use client';

import type { ReactNode } from 'react';

import { headerRef } from '@/components/layout/Header/utils/headerRef';

interface HeaderProps {
    children: ReactNode;
}

export default function Header({ children }: HeaderProps) {
    return (
        <header
            ref={headerRef}
            className="flex z-50 sticky w-full flex-col justify-between top-0"
        >
            {children}
        </header>
    );
}
